var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tailwind Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6803 10.0003C17.6803 14.2419 14.2419 17.6803 10.0003 17.6803C5.75877 17.6803 2.32031 14.2419 2.32031 10.0003C2.32031 5.75877 5.75877 2.32031 10.0003 2.32031C14.2419 2.32031 17.6803 5.75877 17.6803 10.0003ZM10.9603 13.8403C10.9603 14.3705 10.5305 14.8003 10.0003 14.8003C9.47012 14.8003 9.04031 14.3705 9.04031 13.8403C9.04031 13.3101 9.47012 12.8803 10.0003 12.8803C10.5305 12.8803 10.9603 13.3101 10.9603 13.8403ZM10.0003 5.20031C9.47012 5.20031 9.04031 5.63012 9.04031 6.16031V10.0003C9.04031 10.5305 9.47012 10.9603 10.0003 10.9603C10.5305 10.9603 10.9603 10.5305 10.9603 10.0003V6.16031C10.9603 5.63012 10.5305 5.20031 10.0003 5.20031Z",
    fill: "#F5A524"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingButtonIcon);
export default __webpack_public_path__ + "static/media/pending_button_icon.47664f87b310c6f6ff29446a02486e02.svg";
export { ForwardRef as ReactComponent };